<template>
  <div class="service-file-list-item service-file-list-item-image">
    <div class="top">
      <div>
        <a data-fancybox="gallery" class="image" :href="util.getImageUrl(item.url, '1000-')">
          <img :src="util.getImageUrl(item.url, '180x180')" />
        </a>
      </div>
    </div>
    <div class="bottom">
      <el-tooltip :content="item.desc" placement="top-start">
        <div>{{item.name}}</div>
      </el-tooltip>

      <div class="download" @click="onDownload"></div>
    </div>
  </div>
</template>

<script>
import FileListItem from "./FileListItem";
export default {
  name: "FileListItemImage",
  extends: FileListItem,
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss">
.service-file-list-item-image {
}
</style>